module.exports = __webpack_public_path__ + "media/icons/pdf-file@3x-e0a608fd.svg";